import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Preview from "../views/Preview.vue";
import Edit from "../views/Edit.vue";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/preview/?menu=:menu",
        name: "Preview",
        component: Preview
    },
    {
        path: "/?menu=:menu",
        name: "HomeRetour",
        component: Home
    },
    {
        path: "/edit/?menu=:menu",
        name: "Edit",
        component: Edit
    },
    {
        path: "/edit/?menu=:menu",
        name: "EditRetour",
        component: Edit
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
